import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const TABS = [
  { key: 'nieuw',     label: '✍ Nieuw document', path: '/forms/quick-sign-multi', hint: 'PDF/Word/Excel uploaden, handtekening plaatsen, versturen' },
  { key: 'templates', label: '📐 Templates',      path: '/forms',                  hint: 'Vaste formulieren met handtekening altijd op dezelfde plek' },
  { key: 'inbox',     label: '📥 Inbox',          path: '/forms/inbox',            hint: 'Status, herinneren, intrekken, audit' },
  { key: 'brieven',   label: '📝 Brieven',        path: '/brieven',                hint: 'Brieven opstellen en versturen' },
  { key: 'instellingen', label: '⚙ Instellingen', path: '/forms/instellingen',     hint: 'Webhooks, herinneringen, verloop' }
];

export default function FormsTabs({ active, title, right }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const cur = active || (TABS.find(t => t.path !== '/forms' && pathname.startsWith(t.path))?.key) || 'templates';
  const curTab = TABS.find(t => t.key === cur);
  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
        <h1 style={{ margin: 0, fontSize: 22, color: '#1e3a5f' }}>📝 Forms{title ? ` — ${title}` : ''}</h1>
        {right && <div style={{ marginLeft: 'auto' }}>{right}</div>}
      </div>
      <div style={{ display: 'flex', gap: 4, borderBottom: '2px solid #e2e8f0' }}>
        {TABS.map(t => {
          const on = t.key === cur;
          return (
            <button key={t.key} type="button" onClick={() => navigate(t.path)} title={t.hint}
              style={{
                padding: '9px 16px', fontSize: 14, fontWeight: on ? 700 : 500, cursor: 'pointer',
                background: 'transparent', border: 'none', borderBottom: `3px solid ${on ? '#1e3a5f' : 'transparent'}`,
                marginBottom: -2, color: on ? '#1e3a5f' : '#64748b'
              }}>
              {t.label}
            </button>
          );
        })}
      </div>
      {curTab && <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 6 }}>{curTab.hint}</div>}
    </div>
  );
}
